import { request } from '@/axios';
import type {
  ApiRequest,
  UserTagGetReq,
  UserTagAddNewReq,
  UserTagUpdateNewReq,
  GetUserTagResponse,
  AddUserTagResponse,
  UpdateUserTagResponse,
  ImgListReq,
  GetImgListResponse,
  GetTagNewResponse
} from '@/types/userTag';

/**
 * 新版获取用户作品标签
 * @param data 请求参数
 * @returns Promise<GetUserTagResponse>
 */
export const getUserTagNew = (data: UserTagGetReq): Promise<GetUserTagResponse> => {
  return request({
    api: '/api/userTag/getUserTagNew',
    method: 'POST',
    data
  });
};

/**
 * 新版创建用户作品标签
 * @param data 请求参数
 * @returns Promise<AddUserTagResponse>
 */
export const addUserTagNew = (data: UserTagAddNewReq): Promise<AddUserTagResponse> => {
  return request({
    api: '/api/userTag/addUserTagNew',
    method: 'POST',
    data
  });
};

/**
 * 新版修改用户作品标签
 * @param data 请求参数
 * @returns Promise<UpdateUserTagResponse>
 */
export const updateUserTagNew = (data: UserTagUpdateNewReq): Promise<UpdateUserTagResponse> => {
  return request({
    api: '/api/userTag/updateUserTagNew',
    method: 'POST',
    data
  });
};

/**
 * 获取所有生图图片
 * @param data 请求参数
 * @returns Promise<GetImgListResponse>
 */
export const getImgList = (data: ImgListReq): Promise<GetImgListResponse> => {
  return request({
    api: '/api/artwork/imgList',
    method: 'POST',
    data
  });
};

/**
 * 获取兴趣标签
 * @returns Promise<GetTagNewResponse>
 */
export const getTagNew = (): Promise<GetTagNewResponse> => {
  return request({
    api: '/api/userTag/getTagNew',
    method: 'POST'
  });
};

